import React,{useState} from 'react'
import {motion} from 'framer-motion'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../common/SafeIcon'
import { pingSupabase } from '../lib/keepAlive'

const {FiFileText,FiMoreHorizontal,FiArchive,FiUser,FiLogOut,FiDownload,FiInfo,FiTrash2,FiActivity}=FiIcons

const Header=({user,onLogout,archivedInvoices,showArchiveMenu,setShowArchiveMenu,setActiveTab,onOpenCSV})=> {
  const [showUserMenu,setShowUserMenu]=useState(false)
  const [pingStatus, setPingStatus] = useState(null)
  
  // App version
  const APP_VERSION='2.001'
  
  const handleClearCookies=()=> {
    if (window.confirm('Ali ste prepričani,da se želite odjaviti in počistiti piškotke?')) {
      onLogout()
      // Clear any local storage that might exist
      localStorage.clear()
      alert('Piškotki so bili počiščeni.')
    }
  }
  
  const handleManualPing = async () => {
    setPingStatus('pinging');
    try {
      await pingSupabase();
      setPingStatus('success');
      setTimeout(() => setPingStatus(null), 3000);
    } catch (error) {
      setPingStatus('error');
      setTimeout(() => setPingStatus(null), 3000);
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="text-center mb-6"
    >
      <div className="flex items-center justify-between mb-3">
        {/* Logo and Title - Left */}
        <div className="flex items-center">
          <div className="bg-[#6e725c] w-10 h-10 rounded-full flex items-center justify-center mr-3">
            <SafeIcon icon={FiFileText} className="text-xl text-white" />
          </div>
          <div className="text-left">
            <h1 className="text-2xl font-bold text-[#4d504a]">Opomnik računov</h1>
            <p className="text-[#6e725c] text-xs">
              Sledite ponavljajočim se računom
            </p>
          </div>
        </div>

        {/* Right side controls */}
        <div className="flex items-center space-x-2">
          {/* Archive menu */}
          <div className="relative">
            <button
              onClick={()=> setShowArchiveMenu(!showArchiveMenu)}
              className="p-2 text-gray-400 hover:text-[#6e725c] transition-colors"
              title="Več možnosti"
            >
              <SafeIcon icon={FiMoreHorizontal} className="text-lg" />
              {archivedInvoices.length > 0 && (
                <span className="absolute -top-1 -right-1 bg-[#6e725c] text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  {archivedInvoices.length}
                </span>
              )}
            </button>
            {showArchiveMenu && (
              <motion.div
                initial={{ opacity: 0, scale: 0.95, y: -10 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                className="absolute right-0 top-full mt-2 bg-white rounded-lg shadow-lg border py-2 min-w-[200px] z-50"
              >
                <button
                  onClick={()=> {
                    setActiveTab('archive')
                    setShowArchiveMenu(false)
                  }}
                  className="w-full text-left px-4 py-2 text-[#4d504a] hover:bg-gray-100 transition-colors flex items-center"
                >
                  <SafeIcon icon={FiArchive} className="mr-2 text-sm" />
                  Arhiv
                  {archivedInvoices.length > 0 && (
                    <span className="ml-auto text-xs text-[#6e725c]">
                      {archivedInvoices.length}
                    </span>
                  )}
                </button>

                <div className="border-t border-gray-100 my-1"></div>

                <button
                  onClick={()=> {
                    onOpenCSV()
                    setShowArchiveMenu(false)
                  }}
                  className="w-full text-left px-4 py-2 text-[#4d504a] hover:bg-gray-100 transition-colors flex items-center"
                >
                  <SafeIcon icon={FiDownload} className="mr-2 text-sm" />
                  Uvoz/Izvoz CSV
                </button>
                
                <div className="border-t border-gray-100 my-1"></div>
                
                <button
                  onClick={()=> {
                    handleManualPing()
                    // Don't close the menu to show status
                  }}
                  className="w-full text-left px-4 py-2 text-[#4d504a] hover:bg-gray-100 transition-colors flex items-center"
                >
                  <SafeIcon icon={FiActivity} className="mr-2 text-sm" />
                  Preveri povezavo
                  {pingStatus && (
                    <span className={`ml-auto text-xs ${
                      pingStatus === 'pinging' ? 'text-blue-500' : 
                      pingStatus === 'success' ? 'text-green-500' : 
                      'text-red-500'
                    }`}>
                      {pingStatus === 'pinging' ? 'Preverjam...' : 
                       pingStatus === 'success' ? 'Povezava OK' : 
                       'Napaka'}
                    </span>
                  )}
                </button>

                <div className="border-t border-gray-100 my-1"></div>

                <button
                  onClick={()=> {
                    handleClearCookies()
                    setShowArchiveMenu(false)
                  }}
                  className="w-full text-left px-4 py-2 text-orange-600 hover:bg-orange-50 transition-colors flex items-center"
                >
                  <SafeIcon icon={FiTrash2} className="mr-2 text-sm" />
                  Počisti piškotke
                </button>

                <div className="border-t border-gray-100 my-1"></div>

                <div className="px-4 py-2 text-xs text-[#6e725c] flex items-center">
                  <SafeIcon icon={FiInfo} className="mr-2 text-sm" />
                  Verzija {APP_VERSION}
                </div>
              </motion.div>
            )}
          </div>

          {/* User menu */}
          <div className="relative">
            <button
              onClick={()=> setShowUserMenu(!showUserMenu)}
              className="flex items-center space-x-2 p-2 text-[#4d504a] hover:text-[#6e725c] transition-colors"
              title="Uporabniški meni"
            >
              <div className="bg-[#6e725c] w-8 h-8 rounded-full flex items-center justify-center">
                <SafeIcon icon={FiUser} className="text-sm text-white" />
              </div>
              <span className="text-sm font-medium hidden sm:block">{user.email}</span>
            </button>

            {showUserMenu && (
              <motion.div
                initial={{ opacity: 0, scale: 0.95, y: -10 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                className="absolute right-0 top-full mt-2 bg-white rounded-lg shadow-lg border py-2 min-w-[160px] z-50"
              >
                <div className="px-4 py-2 border-b border-gray-100">
                  <p className="text-sm font-medium text-[#4d504a]">{user.user_metadata?.name || 'Uporabnik'}</p>
                  <p className="text-xs text-[#6e725c]">{user.email}</p>
                  <p className="text-xs text-green-600 mt-1">🟢 Povezan</p>
                </div>

                <button
                  onClick={()=> {
                    setShowUserMenu(false)
                    onLogout()
                  }}
                  className="w-full text-left px-4 py-2 text-[#4d504a] hover:bg-gray-100 transition-colors flex items-center"
                >
                  <SafeIcon icon={FiLogOut} className="mr-2 text-sm" />
                  Odjava
                </button>
              </motion.div>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default Header